import Vue from 'vue'
import VueRouter from 'vue-router'
import { CompanyAPI, OrderAPI, ReferralAPI, UserAPI } from '@/api/backend-client'
import routes from '@/router/routes'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

const openOneUrl = (url: string) => {
    const urlParams = new URLSearchParams({
        token: UserAPI.refreshToken,
        redirect: `${process.env.VUE_APP_ONE_APP_BASEURL}${url}`,
    })

    window.open(
        `${process.env.VUE_APP_ONE_APP_BASEURL}/authenticate?` + urlParams.toString(),
        '_blank',
    )
}

const redirectOneUrl = (url: string) => {
    const urlParams = new URLSearchParams({
        token: UserAPI.refreshToken,
        redirect: `${process.env.VUE_APP_ONE_APP_BASEURL}${url}`,
    })

    window.location.href = `${process.env.VUE_APP_ONE_APP_BASEURL}/authenticate?` + urlParams.toString()
}

router.beforeEach((to, from, next) => {
    if (to.params.toOne) {
        // Reroute naar /contact/lead for Beta Keyvue
        if (to.name.startsWith('tasks_detail')) {
            openOneUrl(`/contact/${to.params.contactId}/lead/${to.params.referralId}`)
            return next(false)
        }

        // Reroute naar /contact/order for Beta Keyvue
        if (to.name.startsWith('orders_detail')) {
            openOneUrl(`/contact/${to.params.contactId}/order/${to.params.orderId}`)
            return next(false)
        }

        if (to.name === 'one_contact_detail') {
            openOneUrl(`/contact/${to.params.contactId}`)
            return next(false)
        }

        if (to.name === 'one_settings_virtual_colleague_ai') {
            openOneUrl(`/settings/virtual-colleague/ai`)
            return next(false)
        }
    }

    next()
})

router.beforeResolve(async (to, from, next) => {
    // Skip any permission checks when a route is marked anonymous.
    if (to.meta.anonymous === true) {
        return next()
    }

    // Ensure user and company data are loaded before continuing, otherwise force log out.
    if (!UserAPI.isAuthenticated || !await UserAPI.getCurrentUser() || !await CompanyAPI.getCurrentCompany()) {
        await UserAPI.logout()
        return next({
            name: 'user_login',
            query: {
                redirect: to.path,
            },
        })
    }

    // Check if route has role requirements.
    if (to.meta.requiredRole) {
        const currentUser = await UserAPI.getCurrentUser()

        // If user does not have required role.
        if (currentUser.hasRole(to.meta.requiredRole) === false) {

            // Abort navigation
            return next(false)
        }
    }

    if (to.meta.superAdmin) {
        const currentUser = await UserAPI.getCurrentUser()
        if (!currentUser.superAdmin) {
            return next ({
                name: 'dashboard',
            })
        }
    }

    if (to.meta.condition) {
        const result = await to.meta.condition()
        if (!result) {

            // Abort navigation
            return next(false)
        }
    }

    if (to.name === 'documents') {
        window.location.href = `${ process.env.VUE_APP_ONE_APP_BASEURL }/document?token=${ UserAPI.refreshToken }`

        return next(false)
    }

    let isOneRoute = false
    const oneRoutes = ['tasks_detail', 'orders_detail']
    oneRoutes.forEach(routeName => {
        if (to.name.startsWith(routeName)) {
            isOneRoute = true
        }
    })

    if (isOneRoute) {
        const currentUser = await UserAPI.getCurrentUser()
        if (currentUser.betaOptInEnabled) {
            // Reroute naar /contact/lead for Beta Keyvue
            if (to.name.startsWith('tasks_detail')) {
                const { contact } = await ReferralAPI.get(to.params.referralId)
                redirectOneUrl(`/contact/${contact.id}/lead/${to.params.referralId}`)
                return next(false)
            }

            // Reroute naar /contact/order for Beta Keyvue
            if (to.name.startsWith('orders_detail')) {
                const { referral: { contact } } = await OrderAPI.get(to.params.orderId)
                redirectOneUrl(`/contact/${contact.id}/order/${to.params.orderId}`)
                return next(false)
            }
        }
    }

    next()
})

export default router
